import React, { FC } from 'react'
import { DateTime } from 'luxon'
import { FlexColumn } from '@/atoms/FlexContainers'
import { CircleInfoIcon } from '@/atoms/Icons/CircleInfoIcon'
import { Image } from '@/atoms/Image'
import { Text, TitleXS } from '@/atoms/Text'
import { useTranslate } from '@/utils/translate/translate-client'
import { BonusGiftType } from '@/views/PreSales/hooks/useBonusGift'

function formatDate(endDate: Date) {
  const date = DateTime.fromJSDate(endDate)
  return date.toFormat('MMM d')
}

interface Props {
  bonusGift: BonusGiftType
  onLearnMoreClick: () => void
}

export const BonusGiftCard: FC<Props> = ({ bonusGift, onLearnMoreClick }) => {
  const { t } = useTranslate('tickets')

  return (
    <div className="mx-auto flex w-full items-start gap-3 rounded-2xl border-[2px] border-[#C5C1B6] bg-homestead-tan-200 p-4">
      <div className="relative flex h-[72px] w-[72px] shrink-0 items-center justify-center overflow-hidden rounded-[10px] bg-white p-1">
        <Image src={bonusGift.imageUrl} width={56} height={56} alt="" />
      </div>
      <FlexColumn className="h-full w-full">
        <p className="homestead-eyebrow-sm w-fit  rounded-[4px] bg-homestead-yellow px-2 py-[3px] uppercase text-homestead-primary-blue">
          {t('offerEndsGiveaway', 'Offer Ends {{endDate}}', {
            endDate: `${bonusGift.lastDateToEnter.getMonth() + 1}/${bonusGift.lastDateToEnter.getDate()}`,
          })}
        </p>
        <TitleXS className="mt-1" weight="semibold" color="homestead-primary-blue">
          {t('bonusPrizeOffer', 'Bonus Prize Offer')}
        </TitleXS>
        <Text color="homestead-blue" className="photon-paragraph-sm text-sm">
          {t(
            'bonusPrizeOfferDescriptionV2',
            'Pre-Order Tickets by Monday ({{formattedEndDate}}) for a chance to win our Bonus Prize!',
            { formattedEndDate: formatDate(bonusGift.lastDateToEnter) },
          )}
        </Text>
        <button onClick={onLearnMoreClick} className="ml-auto mt-1 flex items-center gap-1">
          <CircleInfoIcon size={16} color="homestead-blue" />
          <Text color="homestead-blue" className="photon-paragraph-sm text-sm underline">
            {t('learnMoreGiveaway', 'learn more')}
          </Text>
        </button>
      </FlexColumn>
    </div>
  )
}
